import { renderIcon } from '../../SvgIcon.esm.js';

/******************************************************
 * This file was created by scripts/generate.js as part
 * of the build process. Do not edit this file directly.
 ******************************************************/
var iconType = {
  viewBox: "0 0 24 24",
  paths: [{
    d: "M8 6c.55 0 1 .45 1 1v7c0 1.3-.84 2.4-2 2.82V20h1c.55 0 1 .45 1 1l-.0068.1162C8.9352 21.612 8.5107 22 8 22H4c-.55 0-1-.45-1-1l.0068-.1162C3.0648 20.388 3.4893 20 4 20h1v-3.18C3.84 16.4 3 15.3 3 14V7c0-.55.45-1 1-1zm10-4c.55 0 1 .45 1 1v4.27c0 .43.27.81.68.95l.96.32c.81.28 1.36 1.04 1.36 1.9V20c0 1.1-.9 2-2 2h-7c-1.1 0-2-.9-2-2v-9.55c0-.86.55-1.62 1.36-1.9l.96-.32c.41-.14.68-.52.68-.95V3c0-.55.45-1 1-1zm2 16h-7v2h7zM17 7h-1v.28c0 1.29-.82 2.44-2.05 2.84l-.95.32V12h7v-1.56l-.95-.31C17.82 9.72 17 8.57 17 7.28zM7 8H5v3h2zm10-4h-1v1h1z"
  }],
  circles: []
};
var LiquorIcon = function LiquorIcon(props) {
  return renderIcon(props, iconType);
};
export { LiquorIcon };